import React from 'react';
import empresa_1 from '../assets/images/empresa_1.png';
import empresa_2 from '../assets/images/empresa_2.png';
import empresa_3 from '../assets/images/empresa_3.png';
import empresa_4 from '../assets/images/empresa_4.png';
import empresa_5 from '../assets/images/empresa_5.png';
import empresa_6 from '../assets/images/empresa_6.png';
import empresa_7 from '../assets/images/empresa_7.png';
import empresa_8 from '../assets/images/empresa_8.png';

const Client = () => {
    return (
        <section id="cliente" className="client">
            <div className="container">
                <div className="row py-5">
                    <div className="col-12 title-discover text-center">Clientes que já atendemos</div>
                </div>
                <div className="row pb-5">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-6 col-lg-3">
                                <img src={empresa_1} className="img img-fluid" alt="Empresa 1" />
                            </div>
                            <div className="col-6 col-lg-3">
                                <img src={empresa_2} className="img img-fluid" alt="Empresa 2" />
                            </div>
                            <div className="col-6 col-lg-3">
                                <img src={empresa_3} className="img img-fluid" alt="Empresa 3" />
                            </div>
                            <div className="col-6 col-lg-3">
                                <img src={empresa_4} className="img img-fluid" alt="Empresa 4" />
                            </div>
                            <div className="col-6 col-lg-3">
                                <img src={empresa_5} className="img img-fluid" alt="Empresa 5" />
                            </div>
                            <div className="col-6 col-lg-3">
                                <img src={empresa_6} className="img img-fluid" alt="Empresa 6" />
                            </div>
                            <div className="col-6 col-lg-3">
                                <img src={empresa_7} className="img img-fluid" alt="Empresa 7" />
                            </div>
                            <div className="col-6 col-lg-3">
                                <img src={empresa_8} className="img img-fluid" alt="Empresa 8" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Client;